import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as Logger from "js-logger";
import template from "./basket.vue";
import * as Store from "../../store";
import Product from "../../models/Product";

@Component({
  mixins: [template]
})
export default class Basket extends Vue {
  get products(): Array<Product> {
    return Store.readBasket(this.$store);
  }
  get total(): number {
    return this.products.reduce((total: number, p: Product) => {
      return Number(total) + Number(p.donation);
    }, 0);
  }
  removeFromBasket(product: Product) {
    Store.commitFromBasket(this.$store, product);
  }

  get fees(): number {
    let total = this.total;
    let serviceCharge = total * 0.02;
    let gst = serviceCharge * (total <= 2000 ? 0 : 0.18);
    let roundOff = (serviceCharge + gst) * (total <= 2000 ? 0.021 : 0.0243);
    let fee = serviceCharge + gst + roundOff;
    return parseFloat(fee.toFixed(2));
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/basket/index.ts